const isLocalhost = require("./isLocalhost");

module.exports = function getIterableBackendBaseUrl() {
	return isLocalhost() ? "http://localhost/iterable-backend" : "https://itblapi.wpenginepowered.com";
}